(ns pfo.link.controller (:require
                          [pfo.api :as api  :refer [process-error]]
                          [promesa.core :as p]
                          [pfo.link.model :as model]
                          [keechma.next.controller :as ctrl]))

(derive :child-links :keechma/controller)

(defmethod ctrl/handle :child-links
  [{:keys [state*] :as ctrl} event {:keys [link-ids]}]
  (case event
    :load (->> (model/children-by-ids link-ids)
               (p/map (fn [links] (ctrl/transact ctrl #(reset! state* links))))
               (process-error))
    nil))


